<template>
  <a-modal
    v-model:visible="visible"
    :width="500"
    simple
    :ok-button-props="{ status: 'danger' }"
    :ok-loading="loading"
    :ok-text="t('workspaceSettings.members.confirm')"
    :cancel-text="t('workspaceSettings.members.cancel')"
    @ok="handleConfirm"
    @cancel="handleCancel"
  >
    <template #title>
      <div class="remove-member-title">
        <icon-exclamation-circle-fill :size="20" style="color: #f53f3f" />
        <span>{{ t('workspaceSettings.members.removeTitle') }}</span>
      </div>
    </template>
    <div class="remove-member-content">
      <p>{{ t('workspaceSettings.members.removeMessage') }}</p>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { IconExclamationCircleFill } from '@arco-design/web-vue/es/icon';

  const { t } = useI18n();

  const props = defineProps<{
    modelValue: boolean;
    loading?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
    (e: 'confirm'): void;
    (e: 'cancel'): void;
  }>();

  const visible = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
  });

  const handleConfirm = () => {
    emit('confirm');
  };

  const handleCancel = () => {
    visible.value = false;
    emit('cancel');
  };
</script>

<script lang="ts">
  export default {
    name: 'RemoveMemberModal',
  };
</script>

<style lang="less" scoped>
  .remove-member-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 600;
  }

  .remove-member-content {
    padding: 20px 0;

    p {
      margin: 0;
      font-size: 14px;
      color: var(--color-text-2);
      line-height: 1.6;
    }
  }
</style>
